import { Keybinding } from "components/CanvasEditor/lib/keybindings"
import { VIEWPORT_KEYBINDINGS } from "components/CanvasEditor/ViewportShortcuts"

const nudge = (direction: string, arrow: string): Record<string, Keybinding> => ({
  [`NUDGE_${direction}`]: { key: arrow, description: "Nudge 1 mm", group: "Element" },
  [`NUDGE_${direction}_FINE`]: { key: `shift+${arrow}`, description: "Nudge 0.1 mm", group: "Element" },
})

const BADGE_KEYBINDINGS: Record<string, Keybinding> = {
  ...VIEWPORT_KEYBINDINGS,
  UNDO: {
    key: "mod+z", description: "Undo", group: "History", allowWhileTyping: true,
  },
  REDO: {
    key: "mod+y, mod+shift+z", description: "Redo", group: "History", allowWhileTyping: true,
  },
  SELECT_ALL: { key: "mod+a", description: "Select all", group: "Selection" },
  DESELECT: { key: "escape", description: "Deselect", group: "Selection" },
  SELECT_NEXT: {
    key: "tab", description: "Select the next layer", group: "Selection", skipOnControls: true,
  },
  SELECT_PREVIOUS: {
    key: "shift+tab", description: "Select the previous layer", group: "Selection", skipOnControls: true,
  },
  DUPLICATE: { key: "mod+d", description: "Duplicate", group: "Element" },
  DELETE: { key: "delete, backspace", description: "Delete", group: "Element" },
  COPY: { key: "mod+c", description: "Copy", group: "Element" },
  PASTE: { key: "mod+v", description: "Paste", group: "Element" },
  CUT: { key: "mod+x", description: "Cut", group: "Element" },
  FORWARD: {
    key: "mod+bracketright, alt+mod+arrowup", description: "Bring forward", group: "Layer",
  },
  BACKWARD: {
    key: "mod+bracketleft, alt+mod+arrowdown", description: "Send backward", group: "Layer",
  },
  TO_FRONT: { key: "mod+shift+bracketright", description: "Bring to front", group: "Layer" },
  TO_BACK: { key: "mod+shift+bracketleft", description: "Send to back", group: "Layer" },
  ALIGN_LEFT: { key: "alt+keya", description: "Align left", group: "Alignment" },
  ALIGN_RIGHT: { key: "alt+keyd", description: "Align right", group: "Alignment" },
  ALIGN_TOP: { key: "alt+keyw", description: "Align top", group: "Alignment" },
  ALIGN_BOTTOM: { key: "alt+keys", description: "Align bottom", group: "Alignment" },
  CENTER_HORIZONTALLY: { key: "alt+keyh", description: "Centre horizontally", group: "Alignment" },
  CENTER_VERTICALLY: { key: "alt+keyv", description: "Centre vertically", group: "Alignment" },
  ...nudge("LEFT", "arrowleft"),
  ...nudge("RIGHT", "arrowright"),
  ...nudge("UP", "arrowup"),
  ...nudge("DOWN", "arrowdown"),
}

export default BADGE_KEYBINDINGS
